
    export default 
    {
    "chore": {
        "banner": {
            "content": "Entdecken Sie die Reise, die Ihre Pakete machen!",
            "learn_more": "MEHR LERNEN"
        }
    }
}